export const VALID_CHANNELS = process.env.REACT_APP_COMPANY_KEY;